import React, { useState, useCallback } from "react";
import { Input, Button, Card, Col } from "antd";
import { useTranslation } from "react-i18next";
import { useFetch } from "../../hooks/fetch";
import { postBadFeedbackResponse } from "../../api/api";
import ErrorMessage from "../customComponent/customMessages/ErrorMessage";
import { useDashboardBucketsTrackingEvent } from "../../utils/pendo/hooks";
import { PENDO_EVENTS } from "./Constants";
import FeedbackCheckIcon from "../../assets/svg/FeedbackCheckIcon";
import FeedbackCloseIcon from "../../assets/svg/FeedbackCloseIcon";
import {
  FeedbackFormContainerStyle,
  FeedbackFormTitleStyle,
  FeedbackFormContentStyle,
  FeedbackFormInputStyle,
  FeedbackFormSendButtonStyle,
  FeedbackFormSendButtonTextStyle,
  FeedbackFormCloseButtonStyle,
  FeedbackThankYouContainerStyle,
  FeedbackThankYouTextStyle,
  FeedbackThankYouIconStyle
} from "./Styles";

const FeedbackForm = ({ conversationId, messageId, onClose }) => {
  const { t } = useTranslation();
  const [feedbackText, setFeedbackText] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { trackEvent } = useDashboardBucketsTrackingEvent();
  const [postBadFeedback, , postBadFeedbackIsLoading] = useFetch(postBadFeedbackResponse);

  const handleSubmit = useCallback(async () => {
    try {
      trackEvent(PENDO_EVENTS.FEEDBACK_RESPONSE_PROVIDED, {
        conversationId,
        messageId,
        badFeedbackResponse: feedbackText.trim()
      });
      await postBadFeedback(conversationId, messageId, feedbackText.trim());
      setIsSubmitted(true);

      setTimeout(() => {
        onClose();
      }, 5000);
    } catch (error) {
      ErrorMessage(t("ai_chat_bot.errors.failed_submitting_feedback"));
    }
  }, [conversationId, messageId, feedbackText]);

  if (isSubmitted) {
    return (
      <div style={FeedbackThankYouContainerStyle}>
        <Col style={FeedbackThankYouTextStyle}>{t("ai_chat_bot.feedback.thank_you_message")}</Col>
        <Col style={FeedbackThankYouIconStyle}>
          <FeedbackCheckIcon />
        </Col>
      </div>
    );
  }

  return (
    <Card style={FeedbackFormContainerStyle}>
      <Col style={FeedbackFormTitleStyle}>{t("ai_chat_bot.feedback.tell_me_more")}:</Col>

      <Col style={FeedbackFormContentStyle}>
        <Input
          value={feedbackText}
          onChange={(e) => setFeedbackText(e.target.value)}
          placeholder={t("ai_chat_bot.feedback.placeholder")}
          style={FeedbackFormInputStyle}
        />
        <Button
          onClick={handleSubmit}
          loading={postBadFeedbackIsLoading}
          disabled={!feedbackText.trim()}
          style={FeedbackFormSendButtonStyle}
        >
          <span style={FeedbackFormSendButtonTextStyle}>{t("ai_chat_bot.feedback.send")}</span>
        </Button>
      </Col>

      <Button onClick={onClose} icon={<FeedbackCloseIcon />} style={FeedbackFormCloseButtonStyle} />
    </Card>
  );
};

export default FeedbackForm;
